<template>
  <div class="container-Home">
    <el-Button type="text"
    @click="setDanjia"
    >设置单价：{{ unitPrice }}</el-Button>
    <h1 class="last-Table-Number">上次表号<br/>{{ lastTableNumber }}</h1>
    <div class="unit-price" v-show="displayDanjia">
      <label for="unit-price-ID">单价：</label>
      <input
        type="number"
        id="unit-price-ID"
        class="money"
        v-model="unitPrice"
      />
      <p>单价默认0.52</p>
      <el-Button type="danger" class="unit-close" @click="setDanjia">关闭</el-Button>
    </div>
    <input
      type="number"
      placeholder="输入当前表号"
      class="current-Table-Number"
      @blur="calculateElectricityBills"
      v-model="currentTableNumber"
    />
    <div class="result" v-show="result">
      <p>
      {{ result.currentTableNumber }} - {{ result.lastTableNumber }} =
      {{ result.numberOfWords }}(字) * {{ result.unitPrice }} =
      {{ result.money }}
    </p>
    </div>
    <Alter :result="resultData" v-show="alter" @close="closeFn"></Alter>
  </div>
</template>

<script>
import Alter from "@/components/Alter";
import * as api from "@/api/api";
import { showMessage } from "@/utils";
export default {
  data() {
    return {
      currentTableNumber: "",
      unitPrice: 0.52,
      lastTableNumber: 0,
      numberOfWords: "",//字数
      money: "",
      alter: false,
      result: false,
      resultData: {},
      displayDanjia: false
    };
  },
  components: {
    Alter,
  },
  async created() {
    try {
      const result = await api.getLastTableCount();
      if (result) {
        this.lastTableNumber = result.currentTableNumber;
      }
    } catch (err) {
      // 请求被拦截器或后端拒绝（例如 401），在此捕获以避免未处理的 Promise 错误
      console.error('获取上次表号失败：', err);

      // 检查是否为未授权（401）错误
      const status = (err && err.status) || (err && err.response && err.response.status) || (err && err.data && err.data.code);
      if (status === 401) {
        // 清理 token（cookie + localStorage），提示并跳转登录
        try { document.cookie = 'token=;path=/;expires=Thu, 01 Jan 1970 00:00:00 GMT'; } catch (e) {}
        try { localStorage.removeItem('token'); } catch (e) {}
        showMessage({ content: '登录已失效，请重新登录', type: 'warning' });
        this.$router.push('/login');
      } else {
        showMessage({ content: '获取上次表号失败', type: 'error' });
      }
    }
  },
  methods: {
    calculateElectricityBills() {
      if(!this.currentTableNumber) return;
      const count = this.currentTableNumber - this.lastTableNumber;
      if (count <= 0) {
        this.currentTableNumber = "";
        showMessage({
          content: "当前表号写错了！",
          type: "error",
          duration: 2000,
        });
      } else {
        this.numberOfWords = count;
        this.money = (this.numberOfWords * this.unitPrice).toFixed(2);
        this.resultData = {
          lastTableNumber: this.lastTableNumber,
          currentTableNumber: this.currentTableNumber,
          unitPrice: this.unitPrice,
          numberOfWords: this.numberOfWords,
          money: this.money,
          date: new Date()
        };
        this.alter = true;
      }
    },
    closeFn(lastNumber) {
      this.alter = false;
      if (lastNumber) {
        this.lastTableNumber = lastNumber;
        this.currentTableNumber = "";
        this.a = true;
      }
    },
    //设置单价
    setDanjia(){
      this.displayDanjia = !this.displayDanjia;
      if(this.unitPrice == ""){
        this.unitPrice = 0.52;
      }
    }
  },
};
</script>

<style lang="less" scoped>
@import "~@/styles/var.less"; 
.container-Home {
  width: 100%;
  height: 100%;
  overflow: hidden;
  //上次表号
  .last-Table-Number {
    width: 100%;
    height: 100px;
    position: absolute;
    left: 50%;
    top: 10%;
    transform: translate(-50%, 0);
    text-align: center;
    line-height: 100px;
    font-size: 55px;
    color: @primary;
    user-select: none;
    // border: 1px solid #000;
  }
  //当前表号
  .current-Table-Number {
    width: 50vw;
    height: 10vh;
    position: absolute;
    top: 55%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    font-size: 30px;
    border: 1px solid #000;
  }
  // 单价设置
  .unit-price {
    width: 70%;
    height: 30%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    z-index: 9;
    border: 1px solid #000;
    background-color: #fff;
    text-align: center;
    padding-top: 10%;
    box-sizing: border-box;
    #unit-price-ID {
      width: 30%;
      text-align: center;
    }
    p{
      margin: 30px;
      color: red;
    }
    .unit-close{
      width: 100%;
      position: absolute;
      left: 0;
      bottom: 0;
    }
  }
  //结果
  .result {
    width: 100%;
    height: 10%;
    position: absolute;
    top: 70%;
    // background-color: #ccc;
    p {
      width: 100%;
      text-align: center;
    }
  }
}
</style>